import type { PopconfirmProps as AntdPopconfirmProps } from "antd";
import { Popconfirm as AntdPopconfirm } from "antd";
import React from "react";

export interface PopconfirmProps extends AntdPopconfirmProps {
  ariaLabel?: string;
  type: "primary" | "danger";
}

const Popconfirm: React.FC<PopconfirmProps> = ({
  ariaLabel,
  type,
  title,
  description,
  onConfirm,
  onCancel,
  okText,
  okType,
  cancelText,
  icon,
  children,
  ...props
}) => {
  return (
    <AntdPopconfirm
      {...props}
      aria-label={ariaLabel ?? title}
      title={title}
      description={description}
      okText={okText}
      okType={type}
      onConfirm={onConfirm}
      cancelText={cancelText}
      onCancel={onCancel}
      icon={icon ? icon : null}
    >
      {children}
    </AntdPopconfirm>
  );
};

export default Popconfirm;
